import { TradingViewTimeFrames } from "@/components/TradingViewWidgets";
import { atom } from "recoil";

export const selectedTimeFrameState = atom<
  | { label: string; value: string; tradingViewValue: TradingViewTimeFrames }
  | undefined
>({
  key: "selectedTimeFrame",
  default: undefined, // Provide a default value
});

export const setSelectedSymbolState = atom<string | undefined>({
  key: "selectedSymbolState", // Fixed key name to be more accurate
  default: undefined, // Provide a default value
});

export const selectedBrokerState = atom<string | undefined>({
  key: "selectedBroker",
  default: "4", // Provide a default value
});
